import React from 'react'
import intl from 'react-intl-universal'
import styled, { css } from 'styled-components'
import { Flex, Button, Link } from '@raysync/common/components'
import { Media } from '@raysync/common/theme'
import DownloadIcon from '@raysync/common/components/svg/docs-download.jsx'

const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 30px;
  ${Media.phone`
    margin-top: .60rem;
  `}
`
const CardTitle = styled.h4`
  ${({ theme: { color, spacing } }) => css`
    color: ${color.primary};
    height: 76px;
    display: flex;
    align-items: center;
    margin: 0 20px;
    line-height: 24px;
    font-weight: 400;
    font-size: 18px;
    ${Media.phone`
      height: 1.1rem;
      font-size: .3rem;
    `}
  `}
`

const DownloadBox = styled(Button)`
  display: inline-block;
  text-decoration: none;
  color: ${p => p.theme.color.secondary};
  cursor: pointer;
  margin: 0 30px;
  border-radius: 40px 40px 40px 40px;
  border: 2px solid #fd5c1f;
  padding: 6px 30px;
  transition: all 0.2s linear;
  svg {
    transition: all 0.3s linear;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    margin-bottom: 2px;
  }
  :hover {
    background-color: ${p => p.theme.color.secondary};
    color: #fff;
    svg {
      path {
        fill: #fff;
      }
    }
  }
  ${Media.phone`
      font-size: .3rem;
      margin: 0 24px;
      padding: 0 .5rem;
      height: .7rem;
      font-size: .24rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: .32rem;
      svg {
        width: .28rem;
        height: .28rem;
      }
    `}
`
const CardContainer = styled.div`
  width: 440px;
  height: 340px;
  box-shadow: 0px 2px 20px 0px rgba(37, 42, 58, 0.1412);
  margin-bottom: 48px;
  background: #fff;
  border-radius: 20px;
  img {
    width: 100%;
    height: 200px;
  }
  ${Media.phone`
    width: 100%;
    height: unset;
    padding-bottom: .4rem;
    margin-bottom:  .4rem;
    img{
      height: 3.04rem;
    }
  `}
`

class DocumentCard extends React.PureComponent {
  render() {
    const { cards, hasMore } = this.props
    return (
      <React.Fragment>
        <CardWrapper>
          {cards.map(i => (
            <CardContainer key={i.text}>
              <img src={i.img} alt='document card' />
              <CardTitle>{i.text}</CardTitle>
              <DownloadBox
                as='a'
                download
                nofollow
                noindex
                size='large'
                variant='outlined'
                target='_blank'
                href={`https://raysync.oss-cn-shenzhen.aliyuncs.com/setup/document/${i.pdfName}`}
              >
                <DownloadIcon />
                {intl.get('app.document3.download')}
              </DownloadBox>
            </CardContainer>
          ))}
        </CardWrapper>
        {hasMore && (
          <Flex>
            <Link to='/support/document/white-paper'>
              <Button size='large'>{intl.get('app.document.download.more')}</Button>
            </Link>
          </Flex>
        )}
      </React.Fragment>
    )
  }
}

export default DocumentCard
